var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "供应链合作协议",
        visible: _vm.isShow,
        width: "850px",
        "before-close": _setup.close,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c("div", { staticClass: "container-protocol" }, [
            _c("iframe", {
              attrs: {
                height: "100%",
                width: "100%",
                src: "https://wsnbh.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%95%86%E5%AE%B6%E4%BE%9B%E5%BA%94%E9%93%BE%E5%90%88%E4%BD%9C%E5%8D%8F%E8%AE%AE.pdf",
              },
            }),
          ]),
          !_vm.read
            ? _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-top": "12px" },
                  model: {
                    value: _setup.agreeProtocol,
                    callback: function ($$v) {
                      _setup.agreeProtocol = $$v
                    },
                    expression: "agreeProtocol",
                  },
                },
                [_vm._v(" 我已认真阅读并同意协议内容 ")]
              )
            : _vm._e(),
          !_vm.read
            ? _c(
                "div",
                { staticClass: "btns-protocol" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _setup.refuseLoading },
                      on: { click: _setup.refuseProtocolAction },
                    },
                    [_vm._v("拒绝合作")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _setup.agreeLoading },
                      on: { click: _setup.agreeProtocolAction },
                    },
                    [_vm._v("同意合作")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }